// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__MwVvD","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2CGIn"};